import {cs}          from "@Common/react/chain-services";
import {ModuleSwamp} from "@Common/react/module-swamp/module-swamp";
import {sort}        from "@Common/utils/collections";
import {chain}       from "@Common/utils/fs";

import {CommonMethodModules}     from "./common/common-method-modules";
import {InformedDeliveryModules} from "./informed-delivery/informed-delivery-modules";
import {MailingModules}          from "./mailing/mailing-modules";
import {ShippingModules}         from "./shipping/shipping-modules";

export const ScDistributionModules = ({initEnrollment, program, templateOptions, agentId, branchId, next}) => cs(

    ["modules", ({}, next) => ModuleSwamp({
        moduleFeeds: ScDistributionModules1({
            initEnrollment, templateOptions,
            program,
            agentId, branchId,
        }),
        next,
    })],
    ({modules}) => next({
        enrollmentEditor: modules.enrollmentEditor,
        getSummaryLines: modules.summaryLines,
        renderAfter: modules.renderAfter,
        estimatedTotal: modules.getModule("estimatedTotal"),
        getPricePerPiece: modules.getModule("getPricePerPiece"),
        totalQuantity: modules.getModule("totalQuantity"),
        ui: chain(
            modules.ui,
            (_) => sort<any>(_, ({priority}) => priority),
        ),
    }),
);

export const ScDistributionModules1 = (
    {
        initEnrollment, templateOptions,
        program=undefined,
        agentId=undefined,
        branchId=undefined,
    }
) => [
    ...CommonMethodModules({initEnrollment, templateOptions, program, agentId, branchId}),

    ...MailingModules({initEnrollment, templateOptions}),
    ...ShippingModules({initEnrollment, templateOptions, program, agentId}),

    ...InformedDeliveryModules({initEnrollment, templateOptions}),
];


// const isDisabled = (edition) => gt(today(), addDate(parseDate(edition.orderReviewDeadline), 2));

// const parseDate = (str):any => parseDateFormat("yyyy-mm-dd").parseDate(str);
